module.exports = __webpack_public_path__ + "img/minting-background-md.36fa2cf3.jpg";